




























































import { Vue, Prop, Component } from "vue-property-decorator";
import { User as IUser } from "@/api/models/user";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import { studentLimitModule } from "@/plugins/modules-detect";
@Component({
  components: { CustomTableCol, CustomTableItem }
})
export default class SearchUserItem extends Vue {
  @Prop() user!: IUser;
  @Prop() index!: number;
  @Prop({ default: false }) isAdded!: boolean;

  get isStudentLimitModule() {
    return studentLimitModule() && this.$store.state.studentLimit !== 0;
  }

  get isLimitted() {
    return (
      this.isStudentLimitModule && this.$store.getters.IS_BLOCK_ADD_STUDENTS
    );
  }

  entityHandler() {
    this.$emit("entityHandler", this.user);
  }
}
